import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w100 mt20 pad10" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "fl fs18 fw600 ddgrey text-left ml15 mt1" }, "メール・メモ内容を追加 ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "w100 pad10"
}
const _hoisted_6 = {
  class: "fl w50",
  style: {}
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "fs12 fw600 ml5 fl mt3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "fl mt1 mr5" }, "メール内容", -1)
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", {
  class: "mt3",
  style: {"margin-left":"-3px"}
}, [
  /*#__PURE__*/_createTextVNode("テンプレ"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("を利用")
], -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "w100 pad10" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_15 = {
  class: "fl w50",
  style: {}
}
const _hoisted_16 = { class: "fs12 fw600 ml5 fl mt3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "fl mt1 mr5" }, "メモ内容", -1)
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "ml3 fr" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", {
  for: `is_private_`,
  class: "fs12 pointer"
}, " メール内容と同じものを設定", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_22 = {
  key: 0,
  class: "w100 pad10 mt14"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextareaTag = _resolveComponent("TextareaTag")!
  const _component_CheckboxTag = _resolveComponent("CheckboxTag")!
  const _component_ModalTemplates = _resolveComponent("ModalTemplates")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(`w100 mt20 text-left pointer rad8`),
        style: {"border":"1px solid #dfdfdf","padding":"12px 0"},
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleCustomizeMailContent()))
      }, [
        _createElementVNode("img", {
          src: _ctx.$getAssetImageUrl(`/assets/home/mail_icon.png`),
          width: "22",
          height: "22",
          class: "fl mr5 ml10"
        }, null, 8, _hoisted_2),
        _hoisted_3,
        _hoisted_4
      ]),
      (_ctx.openCustomizeMailContent)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                src: _ctx.$getAssetImageUrl(`/assets/home/mail_icon.png`),
                width: "22",
                height: "22",
                class: "fl mr5 ml10"
              }, null, 8, _hoisted_7),
              _createElementVNode("label", _hoisted_8, [
                _hoisted_9,
                _withDirectives(_createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/home/help_icon_dgrey.png`),
                  width: "17",
                  height: "18",
                  class: "fl"
                }, null, 8, _hoisted_10), [
                  [_directive_tooltip, `出席者に送信されるメールに同じ内容が入ります`]
                ]),
                _createTextVNode(":")
              ]),
              _createElementVNode("label", {
                class: _normalizeClass(`circle_button fw600 fr centered fs12 blueAround rad8 mb5 mr10`),
                style: {"width":"65px","padding":"4px 10px"},
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.useTemplate && _ctx.useTemplate(...args)))
              }, _hoisted_12),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_TextareaTag, {
                  placeholder: "当日よろしくお願いいたします。",
                  style: {"height":"120px"},
                  class: "fs14 roundForm mw100",
                  value: _ctx.typedMessage,
                  onInputValue: _ctx.inputMessage
                }, null, 8, ["value", "onInputValue"])
              ]),
              _hoisted_14
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("label", _hoisted_16, [
                _hoisted_17,
                _withDirectives(_createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/home/help_icon_dgrey.png`),
                  width: "17",
                  height: "18",
                  class: "fl"
                }, null, 8, _hoisted_18), [
                  [_directive_tooltip, `調整ページ内に表示されます`]
                ]),
                _createTextVNode(":")
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_CheckboxTag, {
                  value: ``,
                  name: `is_private`,
                  checked: _ctx.sameMailAndMemo,
                  prefix: `is_private`,
                  onClickCheckbox: _ctx.clickSameWithMail,
                  class: "ml1"
                }, null, 8, ["checked", "onClickCheckbox"]),
                _hoisted_20
              ]),
              _hoisted_21,
              (!_ctx.sameMailAndMemo)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createVNode(_component_TextareaTag, {
                      placeholder: "当日は以下のアジェンダを予定しています。",
                      style: {"height":"120px"},
                      class: "fs14 roundForm mw100",
                      value: _ctx.memo,
                      onInputValue: _ctx.inputMemo
                    }, null, 8, ["value", "onInputValue"])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_23
            ]),
            _hoisted_24
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ModalTemplates, {
      members: _ctx.vrm.publicRoom ? _ctx.vrm.publicRoom.members : null,
      appo: _ctx.vrm.publicRoom ? _ctx.vrm.publicRoom.current_appointment : null,
      onDecideTemplate: _ctx.decideTemplate
    }, null, 8, ["members", "appo", "onDecideTemplate"])
  ]))
}